module.exports = __webpack_public_path__ + "img/vk.c86065be.svg";